import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { IConfirmPaymentState } from './confirmPayment.slices';
import { confirmPayment } from './confirmPayment.thunks';

export const reducers = {
  [confirmPayment?.pending.type]: (state: IConfirmPaymentState): void => {
    if (isFeatureEnabled(Features.PlgExternal)) {
      state.loading = true;
    }
  },
  [confirmPayment?.fulfilled.type]: (state: IConfirmPaymentState): void => {
    if (isFeatureEnabled(Features.PlgExternal)) {
      state.loading = false;
    }
  },
  [confirmPayment?.rejected.type]: (state: IConfirmPaymentState): void => {
    if (isFeatureEnabled(Features.PlgExternal)) {
      state.loading = false;
    }
  }
};